module.exports = __webpack_public_path__ + "static/media/165580051962b182c7dcc1f.4162311c.png";